import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="app-footer mt-12 rounded-2xl border px-4 py-4 text-sm no-print">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <span className="app-footer__brand">KlasseFrühstück</span>
        <Link to="/changelog">Changelog</Link>
        <Link to="/datenschutz">Datenschutz</Link>
        <Link to="/impressum">Impressum</Link>
        <span>erstellt von Jan (EF)</span>
      </div>
    </footer>
  );
}

export default Footer;
